<template>
  <div class="main">
   <p>请在电脑端登录</p>
  </div>
</template>

<script>

export default {
  metaInfo: {
    meta: [{ charset: "utf-8" }],
  },
  name: "提示",
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
</style>